export default class DataStorage {
  static clear() {
    const val = localStorage.getItem("inform-update");
    const colorPalette = localStorage.getItem("preferedColorPalette");
    localStorage.clear();
    localStorage.setItem("inform-update", val);
    if (colorPalette)
      localStorage.setItem("preferedColorPalette", colorPalette);
  }
}
